import { useCallback, useState } from 'react'

const usePerformanceStats = () => {
  const [isPanelVisible, setIsPanelVisible] = useState(false)

  const handleTogglePanel = useCallback(() => {
    setIsPanelVisible((prevVal) => !prevVal)
  }, [])

  return {
    isPanelVisible,
    handleTogglePanel,
  }
}

export default usePerformanceStats
